export default {"src":"/_next/static/media/icon_burger.eaebf75c.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};